export function RemovePermission(id: string, dependancy: any[]) {
  console.log(dependancy);
  const isUserExist = dependancy.some((groupingData) =>
    groupingData.find(
      (item: any) =>
        item.created_by === id ||
        item.department_id === id ||
        item.role_id === id ||
        item.cooperation_id === id ||
        item.manager_id === id
    )
  );
  return isUserExist;
}
